import React from "react";

interface ActionBarProps {
  children: React.ReactNode;
  className?: string;
}

export default function ActionBar({ children, className = "" }: ActionBarProps) {
  return <div className={`flex items-center gap-2 ${className}`}>{children}</div>;
}

